import { configureStore } from "@reduxjs/toolkit";
import { thunkExtraArgument } from "domain/store.thunk";
import { authSlice } from "domain/auth/auth.slice";
import { techniquesSlice } from "domain/techniques/techniques.slice";
import { seancesSlice } from "domain/seances/seances.slice";
import { carouselSlice } from "domain/carousel/carousel.slice";
import { activitiesSlice } from "domain/activities/activities.slice";
import { tutorialsSlice } from "domain/tutorials/tutorials.slice";
import { foldersSlice } from "domain/folders/folders.slice";
import { visualSupportsSlice } from "domain/visual-supports/visual-supports.slice";
import { onBoardingSlice } from "domain/on-boarding/on-boarding.slice";
import { aiSearchSlice } from "domain/ai-search/ai-search.slice";
import { consignesSlice } from "domain/consignes/consignes.slice";

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [techniquesSlice.name]: techniquesSlice.reducer,
    [seancesSlice.name]: seancesSlice.reducer,
    [carouselSlice.name]: carouselSlice.reducer,
    [activitiesSlice.name]: activitiesSlice.reducer,
    [tutorialsSlice.name]: tutorialsSlice.reducer,
    [foldersSlice.name]: foldersSlice.reducer,
    [visualSupportsSlice.name]: visualSupportsSlice.reducer,
    [onBoardingSlice.name]: onBoardingSlice.reducer,
    [aiSearchSlice.name]: aiSearchSlice.reducer,
    [consignesSlice.name]: consignesSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      thunk: {
        extraArgument: thunkExtraArgument,
      },
    });
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
